import React, { useState, useEffect } from "react";
import Loadable from "react-loadable";
import logoWhite from "../../Assets/newAsset/lpassets/clearFooter.svg";
import { FiPhone, FiMail, FiSearch } from "react-icons/fi";
import { useParams } from "react-router";
import Loader from "../../components/Loader/Loader";
import Meta from "../../components/Meta";
import { getCall, getCity } from "../../Redux/Actions";
import { connect, useDispatch, useSelector } from "react-redux";
import "./Lp.css";
import Actions from "./LpActions";
import { useLocation, useHistory } from "react-router-dom";
import { Modal } from "react-responsive-modal";
import Popup from "../../components/PopupNotification/LpPopup";
import "./LpNew.css";

const scrollTop = () => {
  window.scroll({
    top: 340,
    left: 0,
    behavior: "smooth",
  });
};

const stepsData = [
  {
    id: 1,
    img:
      "https://staticcdn.redcliffelabs.com/media/gallary-images/None/245666fd-7e57-4dae-90bb-a8381ac0da59.webp",
    desc: "Temperature Checks",
  },
  {
    id: 2,
    img:
      "https://staticcdn.redcliffelabs.com/media/gallary-images/None/5aa857e6-ec25-48f9-a86d-7de73342fa20.webp",
    desc: "Secure Packaging",
  },
  {
    id: 3,
    img:
      "https://staticcdn.redcliffelabs.com/media/gallary-images/None/ac00e3ea-c6c1-4432-8a67-1260075a892f.webp",
    desc: "Stored Safely",
  },
  {
    id: 4,
    img:
      "https://staticcdn.redcliffelabs.com/media/gallary-images/None/84cad4f1-ba4e-40ec-8380-10e1e2223ba8.webp",
    desc: "Regular Sanitization",
  },
  {
    id: 5,
    img:
      "https://staticcdn.redcliffelabs.com/media/gallary-images/None/0b9d508f-c135-4ccb-a61c-d73cd7f25c0a.webp",
    desc: "No Contact Delivery",
  },
];

export const Steps = () => {
  return (
    <div className="safetyDiv">
      <h3>5 Steps to Safety</h3>
      <p>
        <span>10+ Lacs</span> Total orders delivered
      </p>
      <div className="safetySteps">
        {stepsData.map((values, index) => (
          <div className="safety__card" key={values.id}>
            <div className="safety_cardIMG">
              <img width="100%" src={values.img} alt="image"></img>
            </div>
            <div className="steps">
              <span>{values.id}</span>
            </div>
            <div className="safetyStep">
              <span>{values.desc}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

function LpNew(props) {
  const dispatch = useDispatch();

  const ScrolltoTop = Loadable({
    loader: () => import("../../components/Scrolltotop/ScrolltoTop"),
    loading: Loader,
  });

  const ErrorPage = Loadable({
    loader: () => import("../ErrorPage"),
    loading: Loader,
  });
  useEffect(() => {
    dispatch(getCity());
  }, []);
  const navCity = useSelector((state) => state.navCityList);
  const { navCities } = navCity;
  const citiesFromArray = navCities;

  const [userName, setUserName] = useState("");
  const [userNumber, setUserNumber] = useState("");
  const [nameError, setNameEror] = useState("");
  const [phoneError, setPhoneEror] = useState("");
  const [number, setNumber] = useState("898 898 8585");
  const [userCity, setUserCity] = useState("");
  const [open1, setOpen1] = useState(false);
  const onOpenModal1 = () => setOpen1(true);
  const onCloseModal1 = () => setOpen1(false);

  const params = useParams();

  const AliasPackArray = [
    "smart-full-body-checkup-with-kidney-function-kft-test",
    "smart-full-body-checkup-with-liver-function-lft-test",
    "smart-full-body-checkup-with-urine-routine-&-microscopy",
    "smart-full-body-checkup-with-thyroid-tests",
    "smart-full-body-checkup-with-lipid-profile-test",
    "smart-full-body-checkup-with-cbc-test",
  ];
  const pacakgeNameFromUrl = params.slug;

  useEffect(() => {
    if (AliasPackArray.includes(pacakgeNameFromUrl)) {
      props.getLppackageAliasDetails(pacakgeNameFromUrl);
    } else {
      props?.getLppackageDetails(pacakgeNameFromUrl);
    }
  }, []);

  let packDetail = props?.package;
  //GETTING DATA FROM STORE (CITIES NAME) STARTS HERE
  const location = useLocation();

  if (packDetail) {
    try {
      if (
        packDetail.package_city_metainfo &&
        packDetail.package_city_metainfo?.og_tag !== ""
      ) {
        var Og = JSON.parse(packDetail.package_city_metainfo.og_tag);
      } else {
        var Og = JSON.parse(packDetail.og_tag);
      }
    } catch (error) {}
  }
  if (props?.package && props?.package?.faq) {
    try {
      if (props?.package?.faq) {
        var faqData = JSON.parse(props?.package?.faq.replaceAll("Delhi", ``));
      } else {
        var faqData = [];
      }
    } catch (error) {
      console.log(error, "FAQ ERROR");
    }
  }
  if (packDetail) {
    try {
      if (packDetail?.package_city_metainfo) {
        var faqData = JSON.parse(packDetail?.package_city_metainfo?.faq);
      } else if (packDetail?.faq) {
        var faqData = JSON.parse(packDetail?.faq.replaceAll("in Delhi", ``));
      } else {
        var faqData = [];
      }
    } catch (error) {
      console.log(error, "FAQ ERROR");
    }
  }

  if (packDetail) {
    try {
      if (
        packDetail.package_city_metainfo &&
        packDetail.package_city_metainfo?.twitter_card !== ""
      ) {
        var twCard = JSON.parse(packDetail.package_city_metainfo.twitter_card);
      } else {
        var twCard = JSON.parse(packDetail.twitter_card);
        // console.log(twCard, "package not city type");
      }
    } catch (error) {}
  }

  if (packDetail) {
    try {
      if (
        packDetail.package_city_metainfo &&
        packDetail.package_city_metainfo?.scratch_code !== ""
      ) {
        var scratch_codeData = packDetail.package_city_metainfo.scratch_code;
      } else if (packDetail.scratch_code) {
        var scratch_codeData = packDetail.scratch_code.replaceAll(
          "in Delhi",
          ``
        );
      } else {
        var scratch_codeData = false;
      }
    } catch (error) {}
    var recommndedPackage = packDetail.related_packages;
  }

  const [open, setOpen] = useState(false);
  const [openSuccModel, setSucc] = useState(false);

  const openSucess = () => setSucc(true);
  const closeSuccess = () => setSucc(false);

  const onOpenModal = () => {
    setOpen(true);
  };
  const onCloseModal = () => {
    setOpen(false);
    setUserNumber("");
    setUserName("");
    setUserCity("");
    setNameEror("");
    setPhoneEror("");
  };

  const history = useHistory();

  const handelUserName = (e) => {
    // setshowPopUp()
    setUserName(e.target.value);
    const characterRegex = /^([A-Za-z]+[ ]?)+$/;
    setNameEror("");
    if (!e.target.value.match(characterRegex)) {
      setNameEror("invalid user name");
    }
    if (e.target.value == "") {
      setNameEror("");
    }
  };
  const handelPhoneChange = (e, userNumber) => {
    setUserNumber(e.target.value);
    setPhoneEror("");
  };
  const validatePhoneNumber = () => {
    let phoneno = /^\d{10}$/;
    if (!userNumber.match(phoneno) || parseInt(userNumber[0]) < 6) {
      if (userNumber === "") {
        return false;
      } else {
        setPhoneEror("Enter a valid number");
        return false;
      }
    } else {
      return true;
    }
  };
  const handelCityChange = (e) => {
    setUserCity(e.target.value);
  };
  const handelSubmit = (e) => {
    e.preventDefault();
    const checkVal = validatePhoneNumber();
    if (checkVal) {
      const body = {
        name: userName,
        phone_no: userNumber,
        source: "Ecommerce",
        url: `https://redcliffelabs.com${location?.pathname}/Top${location?.search}`,
        city: userCity,
      };
      setUserNumber("");
      setUserName("");
      setUserCity("");
      openSucess();
      dispatch(getCall(body));
       
    }
  };

  const handleSubmitMob = (e) => {
    e.preventDefault();
    const checkVal = validatePhoneNumber();
    if (checkVal) {
      const body = {
        name: userName,
        phone_no: userNumber,
        source: "Ecommerce",
        url: `https://redcliffelabs.com${location?.pathname}/bottom${location?.search}`,
        city: userCity,
      };
      setUserNumber("");
      setUserName("");
      setUserCity("");
      openSucess();
      onCloseModal();
      dispatch(getCall(body));
      // history.push({
      //   search: "?/ThankYou",
      // });
    }
  };

  const SuccessModel = ({ number }) => {
    return (
      <div className="SuccessMsg_upload">
        <h2>
          We have received your information. We shall call you in few minutes to
          confirm the details. For any queries please call us at &nbsp;
          <a href={`tel:+91-${number}`} style={{ color: "blue" }}>
            {number}
          </a>{" "}
          - Team Redcliffe Labs
        </h2>
      </div>
    );
  };

  useEffect(() => {
    setTimeout(() => {
      onOpenModal1();
    }, 60000);
  }, []);

  return props?.loading ? (
    <div
      style={{
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
      }}
    >
      <Loader />
    </div>
  ) : props?.package?.length == 0 ? (
    <div className="errorDIVNo">
      <ErrorPage />
      <div className="footerLp">
        <div className="footerContainer">
          <div className="footerFirstRow">
            <div className="logoIMg">
              <img
                className="lpimg"
                width="100%"
                src={
                  packDetail?.org_type !== "imaging"
                    ? "https://staticcdn.redcliffelabs.com/media/gallary-file/None/6666d24d-f9ef-44e3-8aa7-5230252a55c7.webp"
                    : "https://staticcdn.redcliffelabs.com/media/gallary-file/None/39350684-4581-4a0d-b297-52fb3452aa93.webp"
                }
                alt={logoWhite}
              ></img>
            </div>
            <div></div>
            <div className="footerDesc">
              <p>
                Redcliffe Labs is an accredited advanced diagnostic laboratory
                that aims at providing top-notch consistent and accurate
                laboratory services with modern technology and equipment all
                inclusive of logistics management.
              </p>
            </div>
          </div>
          <div className="footerSecondRow">
            <div className="footerLogo">
              <span>Contact Us</span>
              <div className="emailLogo">
                <span>
                  <FiMail />
                </span>
                care@redcliffelabs.com
              </div>
              <a href={`tel:+91${footerTel}`}>
                <div className="phoneLogo">
                  <span>
                    <FiPhone />
                  </span>
                  {footerTel}
                </div>
              </a>
            </div>
          </div>
          <div className="borderDiv"></div>
          <div className="footerThirdRow">
            <div className="footerMsg">
              <p>
                Disclaimer: As per "Pre-Natal Diagnostic Techniques (Regulation
                and prevention of Misuse) Act, 1994", our labs strictly does not
                determine the sex of the fetus.
              </p>
              <p>
                Redcliffe Labs <br /> © 2022. All rights reserved.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  ) : (
    <div className="SuperClassNormalLp ">
      {packDetail?.meta_title && packDetail?.og_tag && Og && twCard && (
        <Meta
          title={
            packDetail.package_city_metainfo
              ? packDetail.package_city_metainfo.meta_title
              : packDetail.meta_title?.replace("in Delhi", ``)
          }
          description={
            packDetail.package_city_metainfo
              ? packDetail.package_city_metainfo.meta_description
              : packDetail.meta_description?.replace("in Delhi", ``)
          }
          keywords={
            packDetail.package_city_metainfo
              ? packDetail.package_city_metainfo.meta_keyword
              : packDetail.meta_keyword
          }
          canonicalUrl={`https://redcliffelabs.com${location.pathname}`}
        >
          <meta property="robots" content={Og.robots ? Og.robots : ""} />
          <meta
            property="og:title"
            content={Og?.title?.replace("in Delhi", ``)}
          />
          <meta property="og:site_name" content={Og.site} />
          <meta property="og:url" content={Og?.url?.replace("delhi", ``)} />
          <meta property="og:description" content={Og?.description} />
          <meta property="og:type" content={Og?.type} />
          <meta property="og:image" content={Og?.image} />
          {scratch_codeData ? (
            <script type="application/ld+json">{scratch_codeData}</script>
          ) : null}
          <script type="application/ld+json">{JSON.stringify(faqData)}</script>
          <meta name="twitter:card" content={twCard ? twCard.card : ""} />
          <meta name="twitter:site" content={twCard ? twCard.site : ""} />
          <meta
            name="twitter:title"
            content={twCard ? twCard.title?.replace("in Delhi", ``) : ""}
          />
          <meta
            name="twitter:description"
            content={twCard ? twCard.description?.replace("in Delhi", ``) : ""}
          />
          <meta name="twitter:image" content={twCard ? twCard.image : ""} />
        </Meta>
      )}

      <div className="newLpMainCont">
        <div className="newLpImg">
          <img
            className="lpNewBg"
            src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/1a1d2020-eaae-48e9-abd4-7a44d702b71c.svg"
            alt=""
          />
          <img
            className="lpNewBgMob"
            src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/dc740389-5e3e-49b8-a22f-da0b31ef17c4.png"
            alt=""
          />
          <img
            className="lpNewLogo"
            onClick={() => {
              // history.push("/");
              window.location.href = process.env.RAZZLE_APP_BASE_URL
            }}
            src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/d6b4dab8-300a-45be-a2e0-22901dfd7ad1.png"
            alt=""
          />
          {location.pathname.includes("/fb") ||
          location.pathname.includes("/sms") ? (
            <a className="lpNewTelNum" href="tel:+91898 898 9393">
              <div className="LpnewCallUsAt">Call us at</div>
              <div className="lpNewCallUsNumber">898 898 9393</div>
            </a>
          ) : (
            <a className="lpNewTelNum" href="tel:+91898 898 8585">
              <div className="LpnewCallUsAt">Call us at</div>
              <div className="lpNewCallUsNumber">898 898 8585</div>
            </a>
          )}
        </div>
        <div className="lpNewContainer">
          <div className="lpNewContainerRight">
            <div className="lpNewTestHead">FULL BODY CHECK-UP</div>
            {packDetail &&
            packDetail.package_price &&
            packDetail.offer_price ? (
              <div className="lpNewTestPrice">
                <div className="lpNewTestPackagePrice">
                  <span style={{ fontWeight: "500" }}>₹</span>
                  {packDetail?.offer_price}
                </div>
                <div className="lpNewTestOfferPrice">
                  <span style={{ fontWeight: "500" }}>₹</span>
                  {packDetail?.package_price}
                </div>
              </div>
            ) : (
              <div className="lpNewTestPrice">
                <div className="lpNewTestPackagePrice">
                  <span style={{ fontWeight: "500" }}>₹</span>699
                </div>
                <div className="lpNewTestOfferPrice">
                  <span style={{ fontWeight: "500" }}>₹</span>1499
                </div>
              </div>
            )}
            <div className="lpNewTestPrams">
              <p className="lpNewTestPramHead">
                {location.pathname.includes("/smart-full-body-checkup")
                  ? 71
                  : packDetail && packDetail.parameter
                  ? packDetail.parameter
                  : null}{" "}
                {packDetail?.parameter == 1 ? "Test" : "Tests"} Included
              </p>
              <p className="lpNewTestPramDesc">
                {location.pathname.includes("/smart-full-body-checkup")
                  ? "Limited Time Offer (87 Parameters ) Hba1c, Complete Hemogram,Iron Studies, Kidney Function Test, Liver Function Test, Blood Glucose Fasting, Thyroid Profile-Total (T3, T4 & TSH Ultra-sensitive), Lipid Profile, Urine Routine & Microscopy Extended"
                  : packDetail && packDetail.description
                  ? packDetail.description
                  : null}
                {/* {packDetail && packDetail.description
                            ? packDetail.description
                            : null} */}
              </p>
            </div>
            <form id="LpForm" onSubmit={handelSubmit} className="newLpTestForm">
              <div className="newLpTestFormInputCont">
                <div className="newLpTestFormInput">
                  <img
                    src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/e04adca6-379b-49e3-a3b0-9d5e8dcc0a95.png"
                    alt=""
                  />
                  <input
                    onBlur={() => {
                      validatePhoneNumber();
                    }}
                    onChange={handelPhoneChange}
                    value={userNumber}
                    type="text"
                    placeholder="Enter Your Mobile Number*"
                  />
                </div>
                {phoneError != "" ? (
                  <span className="lpNewTestFormError">{phoneError}</span>
                ) : null}
                <div className="newLpTestFormInput">
                  <img
                    src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/6b56adcc-ebd1-42c2-af6d-c2bec7408358.png"
                    alt=""
                  />
                  <input
                    onChange={handelUserName}
                    value={userName}
                    type="text"
                    placeholder="Enter Your Name*"
                    required
                  />
                </div>
                {nameError != "" ? (
                  <span className="lpNewTestFormError">{nameError}</span>
                ) : null}
                <div className="newLpTestFormInput">
                  <img
                    src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/a965bc29-c6ea-4bef-9903-d24e31b41cb7.png"
                    alt=""
                  />
                  <select
                    onChange={handelCityChange}
                    value={userCity}
                    type="text"
                    required
                  >
                    <option value="" disabled selected>
                      Enter Your City*
                    </option>
                    {citiesFromArray && citiesFromArray?.cities
                      ? citiesFromArray.cities.map((values, index) => {
                          return (
                            <option className="lpNewCityDropOpt" value={values}>
                              {values[0].toUpperCase() + values.slice(1)}
                            </option>
                          );
                        })
                      : null}
                  </select>
                  {/* <img src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/b7173267-253e-4730-a917-7719b362e0f3.svg" alt="" /> */}
                </div>
                <button
                  id="LpTop"
                  type="submit"
                  className="newLpTestFormButton"
                >
                  Get A Call Now
                </button>
              </div>
            </form>
          </div>
          <div className="lpNewContainerLeft">
            <img
              src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/b8cdb8ed-ec0a-4a08-8456-09f7da58be71.webp"
              alt=""
            />
            <div className="instantCashbackDiv">
              <div className="instantCashbackTxt">
                <img
                  src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/f975a755-cafc-417d-afd0-3a2e654d4272.svg"
                  alt=""
                />
                Instant Cashback*
              </div>
              <div className="instantCashback300">Rs. 300/-</div>
            </div>
          </div>
        </div>
        {/* >>>>>>Display in Mobile View Only */}
        <div className="lpNewContainerMob">
          <div className="lpNewMobLeft">
            <div className="newLpPackageHeadMob">
              <div className="lpNewTestHeadMob">FULL BODY CHECK-UP</div>
              {packDetail &&
              packDetail.package_price &&
              packDetail.offer_price ? (
                <div className="lpNewTestPriceMob">
                  <div className="lpNewTestPackagePriceMob">
                    <span style={{ fontWeight: "500" }}>₹</span>
                    {packDetail?.offer_price}
                  </div>
                  <div className="lpNewTestOfferPriceMob">
                    <span style={{ fontWeight: "500" }}>₹</span>
                    {packDetail?.package_price}
                  </div>
                </div>
              ) : (
                <div className="lpNewTestPriceMob">
                  <div className="lpNewTestPackagePriceMob">
                    <span style={{ fontWeight: "500" }}>₹</span>699
                  </div>
                  <div className="lpNewTestOfferPriceMob">
                    <span style={{ fontWeight: "500" }}>₹</span>1499
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className="lpNewMobRight">
            <img
              src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/2b7422ed-46ab-463e-9039-04d8065a8df4.webp"
              alt=""
            />
          </div>
        </div>
        <div className="lpnewCashbackMob">
          <div className="lpNewCahbackTxtMob">
            <img
              src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/f975a755-cafc-417d-afd0-3a2e654d4272.svg"
              alt=""
            />
            Instant Cashback*
          </div>
          <div style={{ fontWeight: "900" }} className="lpNew300Mob">
            Rs.300/-
          </div>
        </div>
        <div className="lpNewTestPramsMob">
          <p className="lpNewTestPramHead">
            {location.pathname.includes("/smart-full-body-checkup")
              ? 71
              : packDetail && packDetail.parameter
              ? packDetail.parameter
              : null}{" "}
            {packDetail?.parameter == 1 ? "Test" : "Tests"} Included
          </p>
          <p className="lpNewTestPramDesc">
            {location.pathname.includes("/smart-full-body-checkup")
              ? "Limited Time Offer (87 Parameters ) Hba1c, Complete Hemogram,Iron Studies, Kidney Function Test, Liver Function Test, Blood Glucose Fasting, Thyroid Profile-Total (T3, T4 & TSH Ultra-sensitive), Lipid Profile, Urine Routine & Microscopy Extended"
              : packDetail && packDetail.description
              ? packDetail.description
              : null}
          </p>
        </div>
        <div className="newLpGreenCardCont">
          <div className="newLpGreenCard">
            <img
              src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/9c40a9f1-8067-4bdb-9baf-ba04b4a8d267.png"
              alt=""
            />
            <div className="newLpGreenCardTxt">
              <div className="greenCardMainTxt">
                Free Home Sample Collection
              </div>
              <div className="greenCardSubTxt">from your office or home</div>
            </div>
          </div>
          <div className="newLpGreenCard">
            <img
              src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/a2cb0424-797a-4faa-b363-5eb7e918820d.png"
              alt=""
            />
            <div className="newLpGreenCardTxt">
              <div className="greenCardMainTxt">Free Doctor Consultation</div>
              <div className="greenCardSubTxt">get expert feedback</div>
            </div>
          </div>
          <div className="newLpGreenCard">
            <img
              className="lpNewActualReport"
              src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/edf13f89-08fb-4ee4-88f9-304c846547e2.png"
              alt=""
            />
            <div className="newLpGreenCardTxt">
              <div className="greenCardMainTxt">Get 100% Accurate Reports*</div>
              <div className="greenCardSubTxt">from our high-tech labs</div>
            </div>
          </div>
          <div className="newLpGreenCard">
            <img
              className="newLpBloodTest"
              src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/7506ea81-1b97-4e9c-9948-78cd17442c8d.png"
              alt=""
            />
            <div className="newLpGreenCardTxt">
              <div
                style={{ paddingRight: "20px" }}
                className="greenCardMainTxt"
              >
                3500+ Routine Tests
              </div>
              <div className="greenCardSubTxt">available in our labs</div>
            </div>
          </div>
        </div>
        <div className="lpNewMobFooter">
          <div onClick={onOpenModal} className="lpNewMobFooterInput">
            <img
              src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/e04adca6-379b-49e3-a3b0-9d5e8dcc0a95.png"
              alt=""
            />
            <input
              type="text"
              disabled
              placeholder="Enter Your Mobile Number*"
            />
          </div>
          <button onClick={onOpenModal}>Get A Call Now</button>
        </div>
        <Modal
          open={open}
          onClose={onCloseModal}
          classNames={{
            overlay: "LpNewModalOverlay",
            modal: "LpNewModal",
          }}
          focusTrapped={false}
        >
          <form onSubmit={handleSubmitMob} className="lpModalFormCont">
            <div className="newLpTestFormInput newLpTestFormInputModal">
              <img
                src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/e04adca6-379b-49e3-a3b0-9d5e8dcc0a95.png"
                alt=""
              />
              <input
                onBlur={() => {
                  validatePhoneNumber();
                }}
                onChange={handelPhoneChange}
                value={userNumber}
                type="text"
                placeholder="Enter Your Mobile Number*"
              />
            </div>
            {phoneError != "" ? (
              <span className="lpNewTestFormError">{phoneError}</span>
            ) : null}
            <div className="newLpTestFormInput newLpTestFormInputModal">
              <img
                src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/6b56adcc-ebd1-42c2-af6d-c2bec7408358.png"
                alt=""
              />
              <input
                onChange={handelUserName}
                value={userName}
                type="text"
                placeholder="Enter Your Name*"
                required
              />
            </div>
            {nameError != "" ? (
              <span className="lpNewTestFormError">{nameError}</span>
            ) : null}
            <div className="newLpTestFormInput newLpTestFormInputModal">
              <img
                src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/a965bc29-c6ea-4bef-9903-d24e31b41cb7.png"
                alt=""
              />
              <select
                onChange={handelCityChange}
                value={userCity}
                type="text"
                required
              >
                <option value="" disabled selected>
                  Enter Your City*
                </option>
                {citiesFromArray && citiesFromArray?.cities
                  ? citiesFromArray.cities.map((values, index) => {
                      return (
                        <option className="lpNewCityDropOpt" value={values}>
                          {values[0].toUpperCase() + values.slice(1)}
                        </option>
                      );
                    })
                  : null}
              </select>

              {/* <img src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/b7173267-253e-4730-a917-7719b362e0f3.svg" alt="" /> */}
            </div>
            <button
              type="submit"
              className="newLpTestFormButton newLpTestFormButtonModal"
            >
              Get A Call Now
            </button>
          </form>
        </Modal>
        {/*<<<<<<<<<Display in Mobile View Only */}
        <div className="newLpPopTests">
          <div className="newLpPopTestHead">Popular Test In India</div>
          <div className="lpNewpopTestData">
            Smart Full Body Checkup | Healthy Heart Package | Liver Function
            Test (LFT) | Vitamin D Test | Fatigue Syndrome Test | PCOS Basic
            Screening | Vitamin B12 Test | CRP Test (C Reactive Protein Test) |
            STD Testing | Triple Marker Test | Blood Sugar Test | Arthritis
            Profile Test | Kidney Function Test (KFT) | Thyroid Profile Total
            CBC Test | Arthritis Profile Test | Prolactin Test (PRL) | Fitness
            Check Package | Follicle Stimulating Hormone FSH Test | Cholesterol
            Test | Diabetes Screening | Creatinine Test | ESR Test
          </div>
        </div>
        <div className="lpNewReadAboutUs">
          <div className="newLpPopTestHead">Read About Us on</div>
          <div className="redAboutUsLinks">
            <a
              // href="https://timesofindia.indiatimes.com/business/india-business/gland-pharma-q2-net-up-38/articleshow/87213616.cms"
              target="_blank"
            >
              <img
                src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/06eaac60-f965-44bd-a4e3-3d0e1d1ce28e.png"
                alt=""
              />
            </a>
            <a
              // href="https://economictimes.indiatimes.com/industry/healthcare/biotech/healthcare/redcliffe-labs-plans-to-hire-over-1000-persons-in-next-six-months/articleshow/88127206.cms"
              target="_blank"
            >
              <img
                src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/843f6b02-8abe-41ef-a12c-07f478101423.png"
                alt=""
              />
            </a>
            <a
              // href="https://www.vccircle.com/  chiratae-backed-healthtech-startup-redcliffe-lifetech-eyes-up-to-60-mn-in-fresh-funding"
              target="_blank"
            >
              <img
                src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/3ab0ea20-89a6-4874-b6e3-f19de30478e2.png"
                alt="NABL"
              />
            </a>
            <a
              // href="https://www.financialexpress.com/lifestyle/health/   diagnostics-sector-has-witnessed-changes-due-to-covid-19-towards-home-based-diagnostics-dheeraj-jain/2305782/"
              target="_blank"
            >
              <img
                src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/270c491b-3663-4872-aae1-2cc385f86111.png"
                alt="NABL"
              />
            </a>
            <a
              // href="https://www.businesswire.com/news/home/20211230005124/en/India-Oncology-NGS-Market-Size-Share-Trends-Analysis-2021-2028-A-70.60-Million-Market-by-2028---ResearchAndMarkets.com"
              target="_blank"
            >
              <img
                className="lpNewBwImg"
                src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/5b5cceed-8572-4468-ae9f-77370b2ad9e6.webp"
                alt=""
              />
            </a>
          </div>
        </div>
        <div className="newLpPopTests">
          <div className="newLpPopTestHead">Terms and Conditions</div>
          <div className="lpNewpopTestData lpNewpopTNCData">
            <ul>
              <li>
                You consent Redcliffe Labs to get in touch with you by
                submitting the form at your suitable schedule.
              </li>
              <li>
                Our medical team and consultant will be there to offer guidance
                to make you understand the entire testing procedure cycle. They
                will ensure simplifying the complete process to avert any
                probability of disease.
              </li>
              <li>
                Our health experts will also check your organs and history for
                the purpose of pre-diagnosing and for recommending the essential
                tests. If you have a prescription with you, then you can also
                share that with our medical team. After the confirmation of your
                scheduled appointment, our expert phlebotomist will come and
                visit your address at the given time to collect the blood
                sample.
              </li>
              <li>
                After the confirmation of your scheduled appointment, our expert
                phlebotomist will come and visit your address at the given time
                to collect the blood sample. He/she will also ensure taking
                other samples if required according to your prescription.
              </li>
              <li>
                After the sample is collected then it will be transferred to the
                certified lab to maintain the integrity and quality of the test.
              </li>
              <li>
                After the results are out, our health experts or medical team
                will cross-check the details and will only send you after the
                evaluation. The reports will be sent to you on your mobile or
                email address. Further, you can get in touch with the doctors
                for counseling and they evaluate if everything is fine.
              </li>
              <li>
                We also provide 24*7 customer support that all your queries and
                problems are solved.
              </li>
            </ul>
          </div>
        </div>
        <div className="lpNewEndingTxt">
          Dear customer, we are very happy to know your registration with
          Redcliffe Labs. You consent to the notifications such as health
          checkup reminders, marketing discounts, etc. we may send you over the
          phone by entering your number on the website. You also allow for
          receiving calls from us.
        </div>
      </div>
      <Modal open={openSuccModel} onClose={closeSuccess} center>
        <SuccessModel number={number} />
      </Modal>

      {/* Notification popup */}
      <Modal
        classNames={{
          overlay: "customOverlay",
          modal: "notificationPopup_modal",
        }}
        open={open1}
        onClose={onCloseModal1}
        center
      >
        <Popup setOpen={setOpen1} />
      </Modal>

      {/* <ScrolltoTop /> */}
    </div>
  );
}

const mapStateToProps = (state) => ({
  package: state?.lpPackage?.lpPackageData,
  loading: state?.lpPackage?.loadinglp,
  success: state?.lpPackage?.success,
});

const mapDispatchToProps = (dispatch) => {
  return {
    getLppackageDetails: (lpslug) => {
      dispatch(Actions.getLppackageDetails(lpslug));
    },
    getLppackageAliasDetails: (lpslug) => {
      dispatch(Actions.getLppackageAliasDetails(lpslug));
    },
    getCall: (body) => {
      dispatch(Actions.getCall(body));
    },
  };
};
export default {
  component: connect(mapStateToProps, mapDispatchToProps)(React.memo(LpNew)),
};
